import Konva from 'konva';
import * as buttons from 'smg/buttons';
import { AddCartItems } from 'smg/customer-api/carts';
import { HandleRequestError } from 'smg/errors';
import { ReportValidity } from 'smg/form';
import * as uploads from 'smg/uploads';
import { RemToPx } from 'smg/util';
import { Relref } from '../hugo';
import * as konvautil from '../konva-utils';
import * as stockitems from '../stockitems';

export default async function main() {
    stockitems.InitGallery();
    stockitems.InitSeeMore();
    void stockitems.InitPrices(true);

    const $form = document.querySelector('#stock-item-form') as HTMLFormElement;
    const $fieldset = $form.querySelector('fieldset') as HTMLFieldSetElement;

    const $frontText = document.querySelector('#front-text') as HTMLTextAreaElement;

    const $quantity = document.querySelector('#quantity') as HTMLInputElement;
    const $addToCart = document.querySelector('#add-to-cart') as HTMLButtonElement;

    const $stage = document.querySelector('#stage') as HTMLElement;

    const $canvasParent = document.querySelector('#canvas-parent') as HTMLDivElement;

    const $canvasUploaderLabel = document.querySelector('#canvas-uploader') as HTMLLabelElement;

    const stage = new Konva.Stage({
        container: $canvasParent,
    });

    const trophyFrontImage = await new Promise<Konva.Image>(resolve => {
        const img = new Image();
        img.onload = () =>
            resolve(new Konva.Image({
                image: img,
                draggable: false,
                listening: false,
            }));
        img.src = `${Relref('/')}img/custom-trophies/blank-front.png`;
    });

    const trophyFrontLayer = new Konva.Layer({
        id: 'trophy-front',
        listening: false,
    });
    stage.add(trophyFrontLayer);
    trophyFrontLayer.add(trophyFrontImage);

    const trophyBackImage = await new Promise<Konva.Image>(resolve => {
        const img = new Image();
        img.onload = () =>
            resolve(new Konva.Image({
                image: img,
                draggable: false,
                listening: false,
                x: trophyFrontImage.width(),
            }));
        img.src = `${Relref('/')}img/custom-trophies/blank-back.png`;
    });

    const trophyBackLayer = new Konva.Layer({
        id: 'trophy-back',
        listening: false,
    });
    stage.add(trophyBackLayer);
    trophyBackLayer.add(trophyBackImage);

    const buttonsHeight =
        RemToPx(2.25) + // buttons height with padding
        2 + // buttons border
        0; //RemToPx(2);

    const padding = {
        top: 0, //RemToPx(2),
        right: 0, //RemToPx(2),
        bottom: buttonsHeight,
        left: 0, //RemToPx(2),
    };

    function fitStageIntoParentContainer(firstRun = true) {
        const $stageChildren: ChildNode[] = [];
        if (!firstRun) {
            $stageChildren.push(...Array.from($stage.childNodes));
            $stage.innerHTML = '';
        }

        stage.width($stage.offsetWidth);
        stage.height($stage.offsetHeight);

        if ($stageChildren) {
            for (const c of $stageChildren) {
                $stage.appendChild(c);
            }
        }

        const originalRatios = {
            width: ($stage.offsetWidth - padding.left - padding.right) / (trophyFrontImage.width() + trophyBackImage.width()),
            height: ($stage.offsetHeight - padding.top - padding.bottom) / trophyFrontImage.height(),
        };

        // formula for cover:
        const coverRatio = Math.min(originalRatios.width, originalRatios.height);

        // result:
        const scale = coverRatio;

        stage.scale({ x: scale, y: scale });
        stage.offsetX(-((stage.width() - trophyFrontImage.width() * scale - trophyBackImage.width() * scale) / 2));
        const offsetY = ((stage.height() - padding.bottom) - trophyFrontImage.height() * scale) / 2;
        stage.offsetY(-offsetY);

        $stage.setAttribute('style', `--scale:${scale};--offsetY:${offsetY}px`);
    }

    fitStageIntoParentContainer();
    window.addEventListener('resize', () => fitStageIntoParentContainer(false));

    const textLayer = new Konva.Layer({
        id: 'trophy-back',
        listening: false,
    });
    const text = new Konva.Text({
        x: 132,
        y: 100,
        text: 'Your Text Here',
        fontSize: 40,
        fontFamily: 'Arial',
        fill: '#000',
        align: 'center',
        verticalAlign: 'middle',
        width: 88,
        height: 32,
    });
    textLayer.add(text);
    stage.add(textLayer);

    konvautil.ShrinkText(text, 6);

    $frontText.addEventListener('input', () => {
        text.text($frontText.value);
        text.fontSize(40);
        konvautil.ShrinkText(text, 10);
    });

    let trophyBackUploadID = 0;
    const trophyBackUploadLayer = new Konva.Layer({
        id: 'back-upload',
        x: trophyBackImage.x(),
        y: trophyBackImage.y(),
        width: trophyBackImage.width(),
        height: trophyBackImage.height(),
    });
    const trophyBackUploadImage = new Konva.Image({
        image: new Image(),
    });
    trophyBackUploadLayer.add(trophyBackUploadImage);
    stage.add(trophyBackUploadLayer);

    trophyBackUploadLayer.add(trophyBackUploadImage);

    const trophyBackUploadTransformerLayer = new Konva.Layer({
        id: 'back-upload-transformer',
        x: trophyBackImage.x(),
        y: trophyBackImage.y(),
    });
    const trophyBackUploaderTransformer = new Konva.Transformer({
        anchorStroke: 'dimgray',
        borderStroke: 'dimgray',
        borderDash: [3, 3],
    });
    trophyBackUploadTransformerLayer.add(trophyBackUploaderTransformer);
    stage.add(trophyBackUploadTransformerLayer);

    const $dropContainer = document.querySelector('#drop-container') as HTMLElement;
    $dropContainer.classList.remove('d-none');
    const $stageUploadButton = document.querySelector('#stage-upload-button') as HTMLButtonElement;
    $stageUploadButton.addEventListener('click', () => $canvasUploaderLabel.click());

    const $edit = document.querySelector('#edit') as HTMLButtonElement;
    const $changeImage = document.querySelector('#change-image') as HTMLButtonElement;
    const $done = document.querySelector('#done') as HTMLButtonElement;

    const startTransformMode = () => {
        $edit.classList.add('d-none');
        $changeImage.classList.remove('d-none');
        $done.classList.remove('d-none');

        trophyBackUploadTransformerLayer.show();
    };

    const stopTransformMode = () => {
        $edit.classList.remove('d-none');
        $changeImage.classList.add('d-none');
        $done.classList.add('d-none');

        trophyBackUploadTransformerLayer.hide();
    };

    $edit.addEventListener('click', startTransformMode);
    $changeImage.addEventListener('click', () => $canvasUploaderLabel.click());
    $done.addEventListener('click', stopTransformMode);

    const $stageLoader = document.querySelector('#stage-loader') as HTMLElement;

    const showLoading = () => {
        $stage.style.opacity = '0.5';
        $stage.style.pointerEvents = 'none';
        $stageLoader.classList.remove('d-none');
    };

    const hideLoading = () => {
        $stage.style.opacity = '';
        $stage.style.pointerEvents = '';
        $stageLoader.classList.add('d-none');
    };

    new uploads.Uploader($canvasUploaderLabel, {
        dropZones: [$stage],
        start: showLoading,
        stop: hideLoading,
        success: (thumb, uploadID, blobURL) => {
            trophyBackUploadID = uploadID;

            const maskActualWidth = 175;
            const maskActualHeight = 205;
            const maskOffsetX = 89;
            const maskOffsetY = 38;

            const mask = new Image();
            mask.onload = () => {
                const img = new Image();
                img.onload = () => {
                    const originalRatios = {
                        width: maskActualWidth / img.naturalWidth,
                        height: maskActualHeight / img.naturalHeight,
                    };

                    // formula for cover:
                    const coverRatio = Math.max(originalRatios.width, originalRatios.height);

                    // result:
                    const newImageWidth = img.naturalWidth * coverRatio;
                    const newImageHeight = img.naturalHeight * coverRatio;

                    const newImageX = maskOffsetX - (newImageWidth - maskActualWidth) / 2;
                    const newImageY = maskOffsetY - (newImageHeight - maskActualHeight) / 2;

                    const transformerShape = new Konva.Rect({
                        draggable: true,
                        x: newImageX,
                        y: newImageY,
                        width: newImageWidth,
                        height: newImageHeight,
                    });
                    trophyBackUploadTransformerLayer.add(transformerShape);
                    trophyBackUploaderTransformer.nodes([transformerShape]);

                    const image = new Konva.Shape({
                        sceneFunc: ctx => {
                            ctx.save();
                            ctx.drawImage(mask, -image.x(), -image.y(), mask.naturalWidth, mask.naturalHeight);
                            // TODO typescript version bug?
                            (ctx as unknown as Record<string, string>)['globalCompositeOperation'] = 'source-in';

                            const toRadians = Math.PI / 180;
                            const angleInDeg = trophyBackUploaderTransformer.rotation();
                            ctx.rotate(angleInDeg * toRadians);
                            ctx.drawImage(img, 0, 0, trophyBackUploaderTransformer.width() / stage.scaleX(), trophyBackUploaderTransformer.height() / stage.scaleX());
                            ctx.rotate(-angleInDeg * toRadians);

                            (ctx as unknown as Record<string, string>)['globalCompositeOperation'] = 'source-over';
                            ctx.restore();
                        },
                        hitFunc: ctx => {
                            ctx.rect(0, 0, trophyBackUploaderTransformer.width() / stage.scaleX(), trophyBackUploaderTransformer.height() / stage.scaleX());
                            ctx.fillStrokeShape(image);
                        },
                        x: newImageX,
                        y: newImageY,
                    });
                    trophyBackUploadLayer.add(image);

                    transformerShape.off('dragmove');
                    transformerShape.on('dragmove', () => image.position(transformerShape.position()));

                    transformerShape.off('transform');
                    transformerShape.on('transform', () => image.position(transformerShape.position()));

                    image.on('click', () => startTransformMode);

                    hideLoading();
                };
                img.src = blobURL;

                $dropContainer.parentElement?.removeChild($dropContainer);
                startTransformMode();

                $uploadRequired.forEach($el => $el.classList.add('d-none'));
            };
            mask.src = `${Relref('/')}img/custom-trophies/mask-back.png`;
        },
    });

    const $uploadRequired = document.querySelectorAll('.upload-required');

    document.addEventListener('click', e => {
        if (!trophyBackUploadID) {
            return;
        }

        if (e.target !== $stage && !(e.target instanceof HTMLElement && e.target?.closest('#stage'))) {
            stopTransformMode();
        }
    });

    $form.noValidate = true;
    $form.addEventListener('submit', async e => {
        e.preventDefault();

        if (!trophyBackUploadID) {
            for (const $el of Array.from($uploadRequired)) {
                $el.classList.remove('d-none');
            }
            return;
        }

        if (!ReportValidity($form)) {
            return;
        }

        $fieldset.disabled = true;
        buttons.Start($addToCart);

        stopTransformMode();

        const stageUploads = await uploads.NewFromURL([
            {
                name: 'Trophy',
                mime: 'image/png',
                url: stage.toDataURL(),
            },
            {
                name: 'Cropped Image',
                mime: 'image/png',
                url: trophyBackUploadLayer.toDataURL(),
            },
        ]);

        AddCartItems({
            stockItemID: 'Ee6TABW1J-6BsgJCrBIABA',
            quantity: parseInt($quantity.value, 10),
            customizations: {
                'Front Text': $frontText.value,
            },
            cartItemUploadIDs: [trophyBackUploadID, ...stageUploads.map(u => u.uploadID)],
        }).then(() => {
            window.location.href = Relref('/cart');
        }).catch(err => {
            $fieldset.disabled = false;
            buttons.Stop($addToCart);
            HandleRequestError(err);
        });
    });
}